import React from 'react';
import { ForgetPasswordForm } from '../organisms';

const ForgetPasswordPage = () => {
  return (
    <div className="login-container">
      <div className="login-sidebar">
        <div>
          <div className="login-text">
            <img className="login-logo" src="/img/logo-pnp.svg" />
            <h3>Bem-vindo à recuperação de senha</h3>
          </div>
          <ForgetPasswordForm/>
        </div>
      </div>
      <div className="login-imageholder">
      </div>
    </div>
  )
}

export { ForgetPasswordPage };
